import {default as SalesmanClientList} from './list/ClientList';
import {DashboardScreen as SalesmanClientDashboard} from './dashboard';

export {SalesmanClientList, SalesmanClientDashboard};
